import { Components, Theme } from '@mui/material';

export const breadcrumbsStyles: Components<Theme>['MuiBreadcrumbs'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '500',
      color: theme.palette.primary.main,
      textTransform: 'uppercase',
      letterSpacing: '0.48px',
      '& a': {
        fontWeight: '500',
        textDecoration: 'none'
      }
    })
  }
};
